<template>
  <div class="row">
    <div class="col-lg-3 ml-lg-auto">
      <div class="rounded overflow-hidden bg-white mr-5">
        <div
          class="d-flex justify-content-between align-items-center bg-light p-3"
        >
          <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
          <span>Esqueci minha senha</span>
        </div>
        <div class="p-3">
          <form @submit.prevent="onSubmit">
            <div class="alert alert-success" v-show="msg.success">
              <font-awesome-icon
                :icon="['fas', 'check-circle']"
              ></font-awesome-icon>
              E-mail enviado com sucesso
            </div>

            <div class="form-group">
              <label>Insira seu e-mail:</label>
              <input
                type="text"
                class="form-control"
                v-model="user.email"
                placeholder="Email"
              />
            </div>

            <div class="d-flex justify-content-between">
              <div>
                <button class="bg-secondary btn btn-info ml-auto" @click="goBack()">
                  <font-awesome-icon
                    :icon="['fa', 'arrow-left']"
                  ></font-awesome-icon>
                  Voltar
                </button>
              </div>
              <div>
                <button class="btn btn-info ml-auto">
                  <font-awesome-icon
                    :icon="['fa', 'paper-plane']"
                  ></font-awesome-icon>
                  Enviar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import { useRouter } from 'vue-router'
  import axios from 'axios'

  export default {
    setup() {
      const router = useRouter()
      const user = ref({
        email: '',
      })
      const msg = ref({
        success: false
      })

      const onSubmit = () => {
        var credentials = {
          email: user.value.email
        }

        axios.post('api/recoveryPasswordMail', credentials)
          .then((response) => {
            if (response?.statusText == 'OK') {
              msg.value.success = true
            }
          })
      }

      return {
        router,
        onSubmit,
        user,
        msg,
      }
    },
    methods: {
      goBack() {
        this.router.push('/login');
      },
    }
  }
</script>
